export default "__VITE_ASSET__a3b1861d__"